/**
 * Pausar, detener y cancelar una sesion de dictado.
 *
 * @module presentation/components/dictation/ControlesDeDictado
 */

import { Pause, Play, Square, X } from 'lucide-react'

interface Props {
  grabando: boolean
  transcribiendo: boolean
  pausado: boolean
  onPausar: () => void
  onReanudar: () => void
  onDetener: () => void
  onCancelar: () => void
}

const BOTON =
  'p-2 rounded-md text-gray-300 bg-gray-700 hover:bg-gray-600 transition-colors ' +
  'focus:outline-none focus:ring-2 focus:ring-[var(--primary)]'

export function ControlesDeDictado({
  grabando,
  transcribiendo,
  pausado,
  onPausar,
  onReanudar,
  onDetener,
  onCancelar,
}: Props) {
  if (!grabando && !transcribiendo && !pausado) return null

  return (
    <div className="flex items-center gap-1">
      {grabando ? (
        <button type="button" onClick={onPausar} className={BOTON} title="Pausar el dictado">
          <Pause className="h-4 w-4" />
        </button>
      ) : (
        <button
          type="button"
          onClick={onReanudar}
          disabled={transcribiendo && !pausado}
          className={`${BOTON} disabled:opacity-40`}
          title="Reanudar el dictado"
        >
          <Play className="h-4 w-4" />
        </button>
      )}

      <button
        type="button"
        onClick={onDetener}
        disabled={!grabando}
        className={`${BOTON} disabled:opacity-40`}
        title="Terminar y transcribir"
      >
        <Square className="h-4 w-4 fill-current" />
      </button>

      <button
        type="button"
        onClick={onCancelar}
        className={`${BOTON} hover:bg-red-900/60 hover:text-red-300`}
        title="Cancelar y descartar lo dictado"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  )
}
